<template>
  <v-container fluid pt-0>
    <v-card flat color="background">
      <v-card-title>Add Contact Information</v-card-title>
      <v-card-subtitle
        >Configure the ways by which your clients can reach you</v-card-subtitle
      >
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
            class="py-0"
            v-for="(contact, index) in contacts"
            :key="index"
          >
            <v-text-field
              prepend-icon="delete"
              clearable
              @click:prepend="deleteContact(contact)"
              :name="contact.name"
              :label="contact.display_name"
              v-model="contact.value"
            >
              <template v-slot:append-outer>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      :disabled="enableButton(contact, index)"
                      class="mx-3"
                      color="primary"
                      height="32"
                      @click="updateContact(contact)"
                    >
                      <v-icon small>check</v-icon>
                    </v-btn>
                  </template>
                  <span>Save Contact</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      overlay-opacity="0.2"
      v-model="dialog"
      scrollable
      max-width="690"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Add Contact Info</v-card-title>
        <v-card-subtitle
          >Add more contact information like email, fax etc.</v-card-subtitle
        >
        <v-card-text>
          <v-autocomplete
            v-model="new_contact.type"
            :items="type_data"
            item-text="name"
            item-value="value"
            label="Type"
          ></v-autocomplete>
          <v-text-field
            v-model="new_contact.display_name"
            placeholder="eg. Location Website"
            label="Name"
          ></v-text-field>
          <v-text-field
            v-model="new_contact.value"
            placeholder="eg. www.google.com"
            label="Value"
          ></v-text-field>
          <v-text-field
            v-model="new_contact.display_value"
            placeholder="eg. Google"
            label="Display Value"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog = false"
            color="grey"
            text
            class="text-capitalize"
            >Cancel</v-btn
          >
          <v-btn @click="addNewContact" color="primary" class="text-capitalize"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="dialog = true"
          fab
          fixed
          dark
          bottom
          right
          color="primary"
          v-on="on"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Add Contact Info</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
export default {
  mounted() {
    this.$root.$on('item-deleted', s => {
      this.getLocation()
    })
    this.getLocation()
  },
  data() {
    return {
      contacts: [],
      dialog: false,
      initialContacts: '',
      type_data: [
        { name: 'Website Logo Link', value: 'website' },
        { name: 'Social', value: 'social' },
        { name: 'Email', value: 'email' },
        { name: 'Phone', value: 'phone' },
        { name: 'Website Notice', value: 'website_notice' },
        { name: 'Website Notice Header', value: 'website_notice_header' }
      ],
      new_contact: {
        name: '',
        display_name: '',
        type: '',
        value: '',
        display_value: ''
      }
    }
  },
  methods: {
    async getLocation() {
      let response
      try {
        response = await LocationAPI.getLocationContactDetails(
          this.$route.params.id
        )
      } catch (error) {
        this.contacts = []
        return console.log(error)
      }
      this.contacts = response.data.payload
      this.initialContacts = JSON.parse(JSON.stringify(response.data.payload))
    },
    async addNewContact() {
      this.new_contact.name = this.new_contact.display_name
      this.new_contact.location_id = this.$route.params.id
      let errorMessage = false
      this.contacts.forEach(contact => {
        if (
          contact.name === this.new_contact.name &&
          contact.type === this.new_contact.type
        ) {
          errorMessage = true
        }
      })
      if (errorMessage) {
        this.swal({
          title: 'Error',
          text: 'Contact name should be unique',
          type: 'error'
        })
      } else {
        let response
        try {
          this.spinner(true)
          response = await LocationAPI.addLocationContact(this.new_contact)
          this.spinner(false)
          this.contacts.push(response.data.payload)
          this.initialContacts.push(
            JSON.parse(JSON.stringify(response.data.payload))
          )
          this.swal({
            title: 'Success',
            text: 'Contact added successfully',
            timer: 3000
          })
        } catch (error) {
          this.spinner(false)
          console.log('error.response', error.response)
          this.swal({
            title: 'Error',
            text: error.response.data.payload[0],
            type: 'error'
          })
        }

        this.resetNewContact()
      }
    },
    async deleteContact(contact) {
      this.openDeleteModal({
        title: `Delete ${contact.display_name} ?`,
        callback: () => LocationAPI.deleteLocationContact(contact.id)
      })
    },
    enableButton(item, index) {
      return this.initialContacts[index].value === item.value
    },
    async updateContact(item) {
      try {
        await LocationAPI.updateLocationContacts(item.id, item)
      } catch (error) {
        return console.log(error)
      }
      this.getLocation()
      this.snackbar({
        text: 'Contact updated successfully.',
        color: 'success',
        icon: 'check'
      })
    },
    async resetNewContact() {
      this.dialog = false
      this.new_contact = {
        name: '',
        display_name: '',
        type: '',
        value: '',
        display_value: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
